// ProviderIcons.js
const ProviderIcons = ({ providers }) => {
  const isMobile = window.innerWidth < 768;
  const maxVisible = 2;

  return (
    <>
      {isMobile ? (
        <div
          className="provider-icons-container"
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            gap: '6px',
            width: '100%',
            paddingLeft: '0px',
            paddingTop: '14px',
          }}
        >
          {providers.slice(0, maxVisible).map(provider => {
            const imageName = provider.toLowerCase().replace(/ /g, '-');
            const imagePath = process.env.PUBLIC_URL + `/static/img/providers/${imageName}.jpeg`;
            return (
              <img
                key={provider}
                src={imagePath}
                alt={provider}
                title={provider}
                style={{
                  width: '48px',
                  height: '48px',
                  objectFit: 'contain',
                  borderRadius: '4px',
                }}
                onError={(e) => e.target.style.display = 'none'}
              />
            );
          })}
          {providers.length > maxVisible && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '4px',
                backgroundColor: '#444',
                color: 'white',
                fontSize: '14px',
              }}
              title={providers.slice(maxVisible).join(', ')}
            >
              +{providers.length - maxVisible}
            </div>
          )}
        </div>
      ) : (
        <div
          className="provider-icons-container"
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'flex-end',
            gap: '6px',
            width: '100%',
          }}
        >
          {providers.slice(0, maxVisible).map(provider => {
            const imageName = provider.toLowerCase().replace(/ /g, '-');
            const imagePath = process.env.PUBLIC_URL + `/static/img/providers/${imageName}.jpeg`;
            return (
              <img
                key={provider}
                src={imagePath}
                alt={provider}
                title={provider}
                style={{
                  width: '48px',
                  height: '48px',
                  objectFit: 'contain',
                  borderRadius: '4px',
                }}
                onError={(e) => e.target.style.display = 'none'}
              />
            );
          })}
          {providers.length > maxVisible && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '4px',
                backgroundColor: '#444',
                color: 'white',
                fontSize: '14px',
              }}
              title={providers.slice(maxVisible).join(', ')}
            >
              +{providers.length - maxVisible}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default ProviderIcons;
